<template>
    <header class="header">
        <div class="header_content_block">
            <div class="header_content_block-info">
                <div @click="goToHomeIfNotAlready" class="logo-container">
                    <img src="@/assets/images/logo-pec.png" alt="Логотип">
                </div>
                <NuxtLink to="/upakovka" class="header-link">Упаковка грузов</NuxtLink>
                <NuxtLink to="/documents" class="header-link">Документы</NuxtLink>
            </div>
            <a class="header_content_link_telephone" href="tel:+375 (17) 336-19-99">
                +375 (17) 336-19-99
            </a>
            <div class="burger-menu" @click="toggleMenu">
                <img v-if="!isMenuOpen" src="/images/burger_menu.svg" alt="Burger Menu Icon">
                <img v-else src="/images/close-square.svg" alt="Close Menu Icon">
            </div>
        </div>
        <div class="burger-dropdown" :class="{ 'burger-dropdown--open': isMenuOpen }">
            <div class="burger-dropdown__content">
                <NuxtLink to="/upakovka" class="burger-dropdown__link">Упаковка грузов</NuxtLink>
                <NuxtLink to="/documents" class="burger-dropdown__link">Документы</NuxtLink>
                <a class="burger-dropdown__link" href="tel:+375 (17) 336-19-99">
                    +375 (17) 336-19-99
                </a>
            </div>
        </div>
    </header>
</template>

<script setup>
import { ref } from 'vue';
import { useRoute, navigateTo } from '#app'; 

const isMenuOpen = ref(false);
const route = useRoute();

const toggleMenu = () => {
    isMenuOpen.value = !isMenuOpen.value;
};

const goToHomeIfNotAlready = () => {
    if (route.path !== '/') {
        navigateTo('/');
    }
};
</script>

<style>
.header {
    padding: 22px 0px;
    width: 100%;
    position: relative;
    background: #fff;
    z-index: 101;
    max-width: 1280px;
    margin: 0 auto;
    border-bottom: 1px solid #E4E6E7;

 @media screen and (max-width: 1300px) {
            max-width: unset;
            margin: 0;
            padding: 22px 16px;
    }
}

.header_content_block {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header_content_block-info {
    display: flex;
    align-items: center;
    gap: 40px;
}

.logo-container {
    cursor: pointer;
}

.header-link {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #2B2B2B;
    text-decoration: none;
}

.header_content_link_telephone {
    color: #2B2B2B;
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    text-decoration: none;
}

.burger-menu {
    display: none;
    cursor: pointer;
    z-index: 102;
    width: 40px;
    height: 40px;
}

.burger-menu img {
    width: 100%;
    height: 100%;
}

.burger-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: white;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.5s ease-in-out, padding 0.5s ease-in-out;
    z-index: 100;
}

.burger-dropdown--open {
    max-height: 300px;
    padding-top: 20px;
    padding-bottom: 20px;
}

.burger-dropdown__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
}

.burger-dropdown__link {
    color: #2B2B2B;
    text-decoration: none;
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0;
    padding: 10px 20px;
    text-align: center;
}

@media screen and (max-width: 1279px) {
    .header-link {
        display: none;
    }
    .header_content_link_telephone {
        display: none;
    }
    .burger-menu {
        display: block;
    }
}
</style>


